export default {
  namespaces: true,
  state: {
    breadcrumbList: [],
    collapse: false
  },
  mutations: {
    SET_BREADCRUMB_LIST (state, payload) {
      state.breadcrumbList = payload
    },
    SET_COLLAPSE (state) {
      state.collapse = !state.collapse
    }
  },
  actions: {
    getBreadcrum ({ commit }, payload) {
      const list = []
      payload.matched.forEach(item => {
        if (item.meta.title) {
          list.push(item.meta.title)
        }
      })
      commit('SET_BREADCRUMB_LIST', list)
    }
  }
}
